import { createContext } from "react";


export const ResetPasswordContext = createContext();